export default __webpack_public_path__ + "static/media/tada-fanfare-a-6313.34985921.mp3";